import enquire from 'enquire-js';

/**
 * Move the CTA buttons from the sidebar to under the specialties list on small screens
 */
const init = () => {
	const ctas = document.querySelector('.listing-profile-sidebar__practice-contact-links');
	const single = document.body.classList.contains('single-post');
	const practiceMeta = document.querySelector('.listing-profile__practice-meta');
	const socialLinks = document.querySelector('.listing-profile-sidebar__social-container');
	const sidebar = document.querySelector('.listing-profile-sidebar');

	// bail if we're not on a single page or we don't have CTAs
	if (!single || !ctas) {
		return;
	}

	enquire.register('screen and ( max-width: 768px )', {
		match: () => {
			practiceMeta.insertAdjacentElement('beforeend', ctas);
		},
		unmatch: () => {
			// if we don't have social links, place at the bottom of the sidebar
			if (socialLinks) {
				socialLinks.insertAdjacentElement('beforebegin', ctas);
			} else {
				sidebar.insertAdjacentElement('beforeend', ctas);
			}
		},
	});
};

init();
